import { useQuery } from '@tanstack/react-query';
import { ApiService } from '@/_services/api.service';
import { queryKeys } from './queryKeys';

/**
 * Query hook to fetch messages for a public conversation (no authentication required)
 * Used on the /share/conversation/[id] page
 */
export const usePublicMessagesQuery = (id: string | null) => {
	return useQuery({
		queryKey: queryKeys.publicConversations.messages(id!),
		queryFn: async () => {
			const { data, error } = await ApiService.GetPublicConversationMessages(id!);
			if (error || !data) {
				throw new Error(error?.message || 'Failed to fetch public messages');
			}
			return data;
		},
		enabled: !!id
	});
};
